export default {
    invoice: {
        reference: {
            exists: {
                title  : null,
                message: "Der Prüfbericht ist bereits einem anderen Ereignis von Typ {0} mit der ID {1} zugeordnet!</span>",
                action : "Ereignis anzeigen"
            }
        },

        forwardings: "Weiterleitung für Vandalismus",
        costtypes  : "Kostenart",
        deliverytimes: "Lieferzeit",
        status         : "Rechnungsstatus",
        ordernumber    : "Auftragsnummer",
        invoicenumber  : "Rechnungsnummer",
        warrantyend    : "Gewährleistungsende",
        invoiceDate    : "Rechnungsdatum",
        verificationDate: "Prüfungsdatum",
        sendDate        : "Sendedatum",
        tax            : "Mehrwertsteuer",
        complaintreason: "Reklamationsgrund",
        vandalism      : "Weiterleitung für Vandalismus",
        description    : "Beschreibung",
        price: {
            original   : "Angebotspreis (Ursprung)",
            recommended: "Angebotspreis (Empfehlung)"
        },
        cost: {
            net        : "Ursprungsrechnung",
            material   : "Kosten Material",
            wage       : "Kosten Lohn",
            invoice    : "Korrigierte Rechnung",
            correction : "Korrigierte Rechnung"
        },
        sum: {
            title      : "Gesamtrechnung",
            maintenance: "Gesamtrechnung für Wartung",
            emergency  : "Gesamtrechnung für Notruf"
        },
        item: {
            maintenance: "Rechnungsposten für Wartung ",
            emergency  : "Rechnungsposten für Notruf "
        },
        contract: {
            mnt: "Vertragskonditionen Wartungskosten",
            emc: "Vertragskonditionen Notrufkosten"
        },

        error: {
            "cost-without-netamount"   : "Kosten ohne Rechnungsbetrag",
            "cost-netamount-difference": "Kosten ungleich Rechnung",
        },

        text: {
            success: {
                subject: "Rechnung wurde geprüft",
                content: "Guten Tag, ...",
            }
        },

        doc: {
            header: "Dokument zum Stempeln auswählen",
            stamp: {
                reset  : "Prüfung und Versand zurücksetzen",
                send   : "Mail an Kunden senden",
                execute: "Dokument stempeln",
            },
            reset: {
                query: "Rechnungsprüfungsdatum zurücksetzen",
                text : "Mit JA wird das Rechnungsprüfungsdatum zurückgesetzt. Anschließend kann die Rechnung neu gestempelt und ggf. erneut versendet werden."
            }
        },

        update: {
            status: {
                query: "Status für alle Anlagen?",
                text : "Soll der Status für alle Anlagen der Sammelrechnung übernommen werden? Mit <b>JA</b> wird der Status <b>{0}</b> für alle Anlagen gesetzt. Mit <b>NEIN</b> nur für die Anlage <b>{1}</b>."
            }
        },

        dates: {
            verification: {
                edit: "Prüfungsdatum bearbeiten",
                view: "Prüfungsdatum anzeigen",
            },
            send: {
                edit: "Sendedatum bearbeiten",
                view: "Sendedatum anzeigen",
            }
        }
    },
}